import { Tab } from "../../types/AlgoliaTypes"
import TableItems from "./TableItems"

interface TableProps {
    data: Tab
} 

export default function Table({data}: TableProps) {
    return (
        <TableItems data={data} />
    )
}